<div class="take-survey-wrapper w-full md:m-[0] sm:mt-[2rem]">
  <div class="title-wrapper w-[95%] flex justify-center">
    <div class="title-section w-full">
      <div class="title-content">
        {{surveyDetails?.title}}
      </div>
      <div class="description-content">
        {{surveyDetails?.description}}
      </div>
    </div>
  </div>
  <div class="form-wrapper w-[95%] flex justify-center">
    <hr class="w-[95%] separator">
  </div>

  <div class="survey-form-wrapper w-[95%] flex items-center flex-col">
    <div
      *ngFor="let questions of surveyDetails?.value[0]?.elements"
      class="w-[95%] survey-review-questions">
      <app-review-survey-questions
        [surveyQuestions]="questions"
      ></app-review-survey-questions>
    </div>
  </div>
  <div class="action-button-wrapper w-[95%] flex justify-center">
    <hr class="w-[95%] separator">
  </div>
  <div class="action-wrapper w-[90%] flex justify-start">
    <app-primary-button (handleClick)="backButtonClicked()"
                        class="sm:w-[20%] w-full"
                        type="small">
      Back
    </app-primary-button>
  </div>
</div>
